/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let iti;
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
$('#signup_company_name').autocomplete({
  source(request, response) {
    if (request.term.length > 100) { return; }
    return $.getJSON($('#signup_company_name').data('autocomplete-source'), {term: request.term}).done(response);
  },
  select( event, ui ) {
    if((ui.item.state === 'imported') || (ui.item.state === 'invited')) {
      if($('#signup_membership').length > 0) {
        return window.location = '/signup/'+ui.item.id + '/' + $('#signup_membership').val();
      } else {
        return window.location = '/signup/'+ui.item.id;
      }
    } else {
      $(".signup_company_name ul.parsley-errors-list li").remove();
      return $(".signup_company_name ul.parsley-errors-list").append("<li class='parsley-required'>"+I18n.t("errors.0005")+"</li>");
    }
  }
});


const telInput = document.querySelector('#signup_phone');

if (telInput) {
  iti = intlTelInput(telInput, {
    initialCountry: 'auto',
    nationalMode: false,
    separateDialCode: true,
    hiddenInput: 'hidden_phone',
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.2/js/utils.js',
    geoIpLookup(success, failure) {
      $.get('https://ipinfo.io', (function() {
      }), 'jsonp').always(function(resp) {
        const countryCode = resp && resp.country ? resp.country : '';
        success(countryCode);
      });
    }
  }
  );

  const setCountry = function() {
    const country = iti.getSelectedCountryData();
    return $('#signup_country').prop('value', country.name);
  };

  setCountry();
  telInput.addEventListener('countrychange', () => setCountry());
}

$(document).ready(function() {
  if (($('#payment-form').length > 0) || ($('#signup-form').length > 0)) {
    if ($('#company_id').length > 0) {
     $('#signup_company_name').attr('required', false).addClass('optional').removeClass('required');
     $('#signup_company_name').attr('data-parsley-required', 'false');
    } else {
      $('#signup_company_name').attr('required', true).addClass('required').removeClass('optional');
      $('#signup_company_name').attr('data-parsley-required', 'true');
    }
  }

  return window.Parsley.addValidator('phoneInput', (_v, selector) => iti.isValidNumber()).addMessage('en', 'phoneInput', 'Invalid phone number');
});
